const initialState = {
  'dashboard-v2' : false,
  'newstrak'     : false,
  'log-rocket'   : false
};

export default initialState;
